<template>
  <v-layout>
    <v-flex xs12>
    <v-card class="mt-2" width="100%">
      <v-card-title>
      <v-dialog v-model="dialog" max-width="500px">
        <v-btn color="primary" dark slot="activator" class="mb-2">New Supplier</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form ref="newSupplier" v-model="newSupplierValid">
                  <v-text-field 
                    label="Supplier Name" 
                    v-model="editedItem.Name"
                    :rules="[v => !!v || 'Name is required']" 
                    required>
                  </v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newSupplierValid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="suppliers"
        :search="search"
        item-key="id"
        :loading="tableLoading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.Name }}</td>
          <td class="text-xs-right">
            <v-btn icon class="mx-0" @click.stop="editItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  data () {
    return {
      expanded: false,
      newSupplierValid: false,
      suppliers: [],
      headers: [
        {
          text: 'Name',
          value: 'Name',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'Actions',
          align: 'right',
          sortable: false
        }
      ],
      search: '',
      dialog: false,
      editedIndex: -1,
      engineers: [],
      tableLoading: false,
      editedItem: {
        Name: ''
      },
      defaultItem: {
        Name: ''
      },
      pagination: {
        sortBy: 'Name',
        rowsPerPage: 25,
        page: 1,
        descending: false
      }
    }
  },
  created () {
    this.tableLoading = true
    fireStore.collection('Suppliers').get()
    .then(snap => {
      snap.forEach(doc => {
        let data = doc.data()
        data.id = doc.id
        this.suppliers.push(data)
        this.tableLoading = false
      })
    })
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Supplier' : 'Edit Supplier'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.suppliers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.suppliers.indexOf(item)
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Suppliers').doc(item.id).delete().then(() => { this.suppliers.splice(index, 1) })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        fireStore.collection('Suppliers').doc(this.editedItem.id).set(this.editedItem, {merge: true})
        .then(() => {
          Object.assign(this.suppliers[this.editedIndex], this.editedItem)
          this.close()
        })
      } else {
        fireStore.collection('Suppliers').add(this.editedItem)
        .then((docRef) => {
          this.editedItem.id = docRef.id
          this.suppliers.push(this.editedItem)
          this.close()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Supplier.vue?79e52c44